module.exports = __webpack_public_path__ + "img/05-ABITO-AGADI-SML-STAMPE-LINO-UNITI-LINO-2.a32a274c.jpg";